var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.themes.length > 0)?_c('StackedCardsSwiper',{attrs:{"slides":_vm.themes,"title":_vm.$t('homePage.themesTitle')}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }